<template>

  <BasicLayout></BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'

export default {
  name: 'Home',
  components: {
    BasicLayout
  }
}

</script>

<style lang="scss" scoped>

  @import "../styles/main-colors";

  .container {
    background-color: $background-dark;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue